"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@phishtool/ui");
const page_1 = __importDefault(require("~components/page"));
const routes_1 = __importDefault(require("./router/routes"));
const header_1 = __importDefault(require("~components/header"));
const footer_1 = __importDefault(require("~components/footer"));
const cookie_banner_1 = __importDefault(require("~components/cookie-banner"));
const not_found_1 = __importDefault(require("~pages/not-found"));
const error_1 = __importDefault(require("~components/error"));
const global_style_1 = __importDefault(require("~styles/global-style"));
const analytics_1 = require("@phishtool/analytics");
const App = () => {
    (0, analytics_1.useAnalytics)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ui_1.GlobalStyle, {}), (0, jsx_runtime_1.jsx)(global_style_1.default, {}), (0, jsx_runtime_1.jsx)(header_1.default, {}), (0, jsx_runtime_1.jsx)(page_1.default, { children: (0, jsx_runtime_1.jsx)(ui_1.Router, { routes: routes_1.default, titlePrefix: "PhishTool", NotFoundComponent: not_found_1.default, ErrorComponent: error_1.default, workspace: null }) }), (0, jsx_runtime_1.jsx)(footer_1.default, {}), (0, jsx_runtime_1.jsx)(cookie_banner_1.default, {}), (0, jsx_runtime_1.jsx)("div", { id: "portal" })] }));
};
exports.default = App;
